"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GraphTable = GraphTable;
var _react = _interopRequireDefault(require("react"));
var _components = require("../../components");
var _base = require("../../base");
var _animations = require("../../shared/animations");
var _styled = require("./styled");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
//
// Main component
// -------------------------------------------------------------------------------------------------

function GraphTable({
  children,
  placeholder
}) {
  const placeholderCss = placeholder.hasData ? {} : {
    '&::after': {
      content: placeholder.text
    }
  };
  return /*#__PURE__*/_react.default.createElement(_styled.Table, {
    placeholder: !placeholder.hasData,
    css: placeholderCss,
    "data-testid": "graph-table"
  }, /*#__PURE__*/_react.default.createElement("tbody", null, children));
}

//
// Utility components
// -------------------------------------------------------------------------------------------------

GraphTable.Loadable = Loadable;
function Loadable({
  loading,
  placeholder,
  ...props
}) {
  const isLoading = (0, _components.useLoadable)(loading);
  if (!isLoading) return /*#__PURE__*/_react.default.createElement(GraphTable, _extends({
    placeholder: placeholder
  }, props));
  return /*#__PURE__*/_react.default.createElement(_base.Box, {
    bg: "$gray300",
    css: {
      animation: `${_animations.pulse} 1.5s linear infinite`,
      height: `300px`,
      width: `500px`
    },
    r: true,
    testId: "graph-table-loading"
  });
}
GraphTable.Label = Label;
function Label({
  label
}) {
  return /*#__PURE__*/_react.default.createElement(_styled.StyledLabel, null, /*#__PURE__*/_react.default.createElement(_styled.TrucatedText, {
    nowrap: true,
    title: label
  }, label));
}
GraphTable.Row = Row;
function Row({
  children,
  css: cssProps,
  hideValue = false,
  value
}) {
  return /*#__PURE__*/_react.default.createElement(_styled.StyledRow, null, children, /*#__PURE__*/_react.default.createElement(_styled.Graph, {
    css: cssProps,
    hiddenValue: hideValue
  }, value));
}